module.exports = __webpack_public_path__ + "img/背景1.bc1ebfa2.jpg";